import { Play, Pause, X } from "lucide-react";
import { useAudio } from "@/context/AudioContext";
import { MINI } from "@/constants/testIds";
import SoundWaves from "@/components/SoundWaves";

const MiniPlayer = () => {
  const { current, isPlaying, isAudible, reconnecting, toggle, stop } = useAudio();
  if (!current) return null;

  return (
    <div
      data-testid={MINI.root}
      className="fixed left-0 right-0 z-40 border-t border-white/10"
      style={{
        bottom: "60px",
        background: "rgba(13,27,75,0.96)",
        backdropFilter: "blur(16px)",
      }}
    >
      <div className="max-w-6xl mx-auto flex items-center gap-3 px-3 py-2.5">
        <img
          src={current.cover}
          alt=""
          className="w-11 h-11 rounded-lg object-cover flex-shrink-0"
        />
        <div className="min-w-0 flex-1">
          <div
            data-testid={MINI.title}
            className="text-white text-sm font-semibold truncate"
          >
            {current.title}
          </div>
          <div className="text-white/60 text-xs truncate">
            {reconnecting ? "Reconectando…" : current.subtitle}
          </div>
        </div>
        <SoundWaves playing={isAudible} bars={4} className="h-5" />
        <button
          data-testid={MINI.toggle}
          onClick={toggle}
          className="w-10 h-10 rounded-full bg-white text-[var(--fi-blue)] flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
          aria-label={isPlaying ? "Pausar" : "Tocar"}
        >
          {isPlaying ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
        </button>
        <button
          data-testid={MINI.close}
          onClick={stop}
          className="w-8 h-8 rounded-full text-white/70 hover:text-white hover:bg-white/10 flex items-center justify-center transition-colors"
          aria-label="Fechar player"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MiniPlayer;
